<div #card="tuiActiveZone" (tuiActiveZoneChange)="onZoneChange($event)">
  <div class="flex gap-x-2 mb-2">
    <app-autocomplete
      class="w-2/12"
      [formControl]="orderForm.controls.clientJson.controls.id"
      [items]="catalogs.clients$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Мой клиент"
      [labelOutside]="false"
      (valueChanged)="onClientChange()"
    ></app-autocomplete>
    <app-autocomplete
      class="w-2/12"
      label="Адрес"
      [labelOutside]="false"
      (valueChanged)="onAddressChange()"
      [formControl]="
        orderForm.controls.clientAddressWithCoordinatesJson.controls.address
      "
      [items]="availableAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      tuiTextfieldSize="m"
      >Адрес</app-autocomplete
    >
    <app-autocomplete
      class="w-2/12"
      [formControl]="orderForm.controls.farmJson.controls.id"
      [items]="catalogs.farms$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник"
      [labelOutside]="false"
      (valueChanged)="onFarmChange()"
    ></app-autocomplete>
    <app-autocomplete
      class="w-2/12"
      [formControl]="orderForm.controls.farmAddress.controls.address"
      [items]="availableFarmAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      [displayValue]="'address'"
      [itemSearch]="'address'"
      label="Адрес"
      [labelOutside]="false"
      (valueChanged)="onFarmAddressChange($event)"
    ></app-autocomplete>
    <app-autocomplete
      class="w-2/12"
      [formControl]="orderForm.controls.flowerType"
      [items]="availableFlowerTypes$ | async"
      [itemSearch]="'search'"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      label="Группа товаров"
      [labelOutside]="false"
    ></app-autocomplete>

    <div class="w-1/12 flex items-center">
      <tui-toggle
        [formControl]="orderForm.controls.imported"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Импорт</span>
    </div>
    <div class="w-1/12 flex items-center">
      <app-checkbox [formControl]="orderForm.controls.cold"></app-checkbox>
      <span class="px-2">Холод</span>
    </div>
  </div>
  <div class="flex gap-x-2 mb-2" *tuiLet="isImport$ | async as isImport">
    <div class="w-2/12">
      <app-autocomplete
        label="Код покупателя"
        [strict]="false"
        [labelOutside]="false"
        [formControl]="orderForm.controls.buyerCode"
        [items]="buyersOfSelectedFarm$ | async"
        [itemSearch]="'search'"
        [itemValue]="'code'"
        [displayValue]="'code'"
        [itemText]="'code'"
      ></app-autocomplete>
    </div>
    @if (isImport) {
      <div class="flex gap-x-2 w-5/12">
        <app-autocomplete
          class="w-2/12"
          [items]="countries()"
          [itemText]="'name'"
          [itemValue]="'letterCode'"
          [itemSearch]="'search'"
          [formControl]="orderForm.controls.countryLetter"
        ></app-autocomplete>
        <tui-input
          class="w-[150px]"
          [formControl]="orderForm.controls.airWaybillNumber"
          tuiTextfieldSize="m"
          >AWB</tui-input
        >
        <div class="flex items-center max-h-[45px]">
          <app-checkbox
            [formControl]="orderForm.controls.precooling"
            [tuiHint]="precooling"
          ></app-checkbox>
          <ng-template #precooling> Pre-cooling </ng-template>
        </div>

        <tui-input-number
          class="w-3/12"
          tuiTextfieldSize="m"
          [formControl]="orderForm.controls.weight"
          >Вес</tui-input-number
        >
        <tui-input-number
          class="w-3/12"
          tuiTextfieldSize="m"
          [formControl]="orderForm.controls.precoolingWeight"
          >Вес pre-cooling</tui-input-number
        >
      </div>
    }
    <div [class]="isImport ? 'w-5/12' : 'w-10/12'">
      <app-cargo-place-details
        *ngFor="
          let details of orderForm.controls.cargoPlacesJson.controls;
          let index = index;
          let last = last
        "
        [isImport]="(isImport$ | async)!"
        [last]="last"
        [cargoPlaceDetailsForm]="details"
      ></app-cargo-place-details>
    </div>
  </div>
  <div class="flex gap-x-2">
    <app-autocomplete
      label="Посредник"
      [labelOutside]="false"
      class="w-2/12"
      [formControl]="orderForm.controls.brokerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      (valueChanged)="fillBrokerJson($event)"
    >
    </app-autocomplete>
    <div class="w-[140px] flex items-center">
      <tui-toggle
        [formControl]="orderForm.controls.prepayment"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Предоплата</span>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [formControl]="orderForm.controls.paymentDate"
        label="Дата платежа"
        [labelOutside]="false"
      ></app-input-date>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [labelOutside]="false"
        [formControl]="orderForm.controls.expectedLoadingDate"
        label="Дата загрузки (оритент.)"
      ></app-input-date>
    </div>
  </div>
</div>
